import * as React from 'react'

import { ViewBase } from '@bestyled/primitives'
import {
  borderProps,
  BorderProps,
  commonProps,
  CommonProps
} from '@bestyled/system'
import styled from 'styled-components'

export interface TooltipBaseProps extends BorderProps, CommonProps {
  ontop?: boolean
  onright?: boolean
  onbottom?: boolean
  onleft?: boolean
  x?: string
  y?: string
  className?: string
}

const TooltipBox = styled<React.FC<TooltipBaseProps>>(ViewBase('TooltipBox'))`
  ${borderProps}
  ${commonProps}
  position: absolute;

  border-radius: 3px;
  border-style: solid;
  border-width: 0.1rem;

  bottom: ${(props) => (props.ontop ? '100%' : null)};
  left: ${(props) =>
    props.ontop || props.onbottom ? '0' : props.onright ? '100%' : null};
  top: ${(props) =>
    props.onbottom ? '100%' : props.onleft || props.onright ? '0' : null};
  right: ${(props) => (props.onleft ? '100%' : null)};

  margin-top: ${(props) =>
    props.onbottom ? '0.4rem' : props.onleft || props.onright ? props.y : null};
  margin-bottom: ${(props) => (props.ontop ? '0.4rem' : null)};
  margin-right: ${(props) => (props.onleft ? '0.4rem' : null)};
  margin-left: ${(props) =>
    props.onright ? '0.4rem' : props.onbottom || props.ontop ? props.x : null};
`

const TooltipTriangle = styled<React.FC<TooltipBaseProps>>(
  ViewBase('TooltipTriangle')
)`
  position: absolute;

  left: ${(props) => (props.onleft ? '100%' : null)};
  right: ${(props) => (props.onright ? '100%' : props.onright ? null : '50%')};
  top: ${(props) => (props.ontop ? '100%' : props.onbottom ? null : '50%')};
  bottom: ${(props) => (props.onbottom ? '100%' : null)};

  border: 0.4rem solid #00000000;
  margin-top: ${(props) => (props.onright || props.onleft ? '-0.4rem' : null)};
  margin-left: ${(props) => (props.ontop || props.onbottom ? '-0.4rem' : null)};

  border-bottom-width: ${(props) => (props.ontop ? 0 : null)};
  border-top-color: ${(props) =>
    props.ontop ? props.theme.colors[props.borderColor as string] : null};

  border-top-width: ${(props) => (props.onbottom ? 0 : null)};
  border-bottom-color: ${(props) =>
    props.onbottom ? props.theme.colors[props.borderColor as string] : null};

  border-left-width: ${(props) => (props.onright ? 0 : null)};
  border-right-color: ${(props) =>
    props.onright ? props.theme.colors[props.borderColor as string] : null};

  border-right-width: ${(props) => (props.onleft ? 0 : null)};
  border-left-color: ${(props) =>
    props.onleft ? props.theme.colors[props.borderColor as string] : null};
`

export const TooltipBase: React.FC<TooltipBaseProps> = (props) => {
  const { ontop, onright, onbottom, onleft, borderColor, className, bg } = props

  return (
    <TooltipBox
      className={className}
      bg={bg}
      borderColor={borderColor}
      onright={onright}
      onleft={onleft}
      onbottom={onbottom}
      ontop={ontop}
    >
      {props.children}
      <TooltipTriangle
        borderColor={borderColor}
        onright={onright}
        onleft={onleft}
        onbottom={onbottom}
        ontop={ontop}
      />
    </TooltipBox>
  )
}
